import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { ComponentProps } from 'react';

export const Button = styled(motion.button, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'sx',
})<{
  variant?: 'solid' | 'outline' | 'text';
}>(({ theme, variant = 'solid' }) => ({
  height: variant === 'text' ? 'auto' : 50,
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: variant === 'text' ? 'unset' : '999px',
  'not(:focus-visible)': {
    outline: 'none',
  },
  border: variant === 'text' ? 'none' : `1.5px solid ${theme.palette.primary.main}`,
  backgroundColor: variant === 'solid' ? theme.palette.primary.main : '#fff',
  color: variant === 'solid' ? '#fff' : theme.palette.primary.main,
  padding: variant === 'text' ? '0' : '0 17px',
  fontSize: variant === 'text' ? 'inherit' : 14,
  fontWeight: 600,
  ':disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  '[disabled]': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  '.left_icon': {
    marginRight: 6,
  },
  '.button_img': {
    marginRight: 6,
    maxWidth: 18,
    maxHeight: 18,
  },
}));

export type ButtonProps = ComponentProps<typeof Button>;
